<div class="center">
  <div>
  <img class="xero-logo" src="../../../../../../../../assets/stripe/stripe-logo.png">
  <div class="waiting">{{'onboarding.messages.finishing_off' | translate}}</div>
  </div>
</div>